import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { toggleTheme } from 'app/providers/themeSlice';

export function usePlatformTheme() {
  const dispatch = useAppDispatch();
  const resolved = useAppSelector((s) => s.theme.resolved);

  return {
    isDark: resolved === 'dark',
    resolved,
    toggleTheme: () => dispatch(toggleTheme()),
  };
}
